// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IRJa","type":"styles_type__33fXk","choices":"styles_choices__1hE-i"};